export const MEETING_LINK_TYPE = {
    NONE: 'NONE',
    AUTO: 'AUTO',
    MANUAL: 'MANUAL',
  }
  